import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

/**
 * Shared direct-manipulation row shell. Business content and layout remain in
 * the host feature; this component keeps drag feedback and return motion
 * identical anywhere a collection is reordered.
 */
const DraggableCollectionRow = ({
  draggableId, index, className, children, rowProps, disabled, portalWhileDragging,
}) => (
  <Draggable draggableId={draggableId} index={index} isDragDisabled={disabled}>
    {(provided, snapshot) => {
      const draggableStyle = provided.draggableProps.style || {};
      const returnStyle = snapshot.isDropAnimating ? {
        transitionDuration: '340ms',
        transitionTimingFunction: 'cubic-bezier(.2, .78, .2, 1)',
      } : {};
      const row = (
        <div
          {...rowProps}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...draggableStyle, ...returnStyle }}
          data-collection-row
          className={`${className} ${snapshot.isDragging ? 'is-dragging' : ''} ${snapshot.isDropAnimating ? 'is-returning' : ''}`.trim()}
        >
          <span className="fp-drag-signifier" aria-hidden="true"><DragIndicatorIcon /></span>
          {children}
        </div>
      );
      return portalWhileDragging && snapshot.isDragging && typeof document !== 'undefined'
        ? createPortal(row, document.body)
        : row;
    }}
  </Draggable>
);

DraggableCollectionRow.propTypes = {
  draggableId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  rowProps: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
  portalWhileDragging: PropTypes.bool,
};

DraggableCollectionRow.defaultProps = {
  className: '', rowProps: {}, disabled: false, portalWhileDragging: false,
};

export default DraggableCollectionRow;
